// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MonthRangePicker_pickerContainer__3u5Jx {
  /* Make picker fill its parent column and allow it to shrink to fit */
  width: 100%;
  max-width: 280px; /* keep the original compact max width */
  box-sizing: border-box;
  padding: 0.4rem; /* small padding to tighten layout */
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #ffffff;
  transition: all 0.12s ease-in-out;
}
.MonthRangePicker_pickerContainer__3u5Jx.MonthRangePicker_open__ccewb {
  border-color: #d21919; /* highlight border */
  box-shadow: 0 0 8px rgba(25, 118, 210, 0.4); /* glow when open */
}

.MonthRangePicker_header__3QM1m {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  font-weight: 600;
  font-size: 0.9rem; /* smaller header text */
}

.MonthRangePicker_header__3QM1m button {
  background: none;
  border: none;
  font-size: 0.85rem;
  cursor: pointer;
  color: #007bff;
}

.MonthRangePicker_header__3QM1m button:disabled {
  color: #9e9d9d;
  cursor: not-allowed;
}

.MonthRangePicker_monthsGrid__s9We\\+ {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.08rem; /* almost no gap between month buttons */
  position: relative;
}

.MonthRangePicker_monthButton__uPx2F {
  /* Make the button fill the grid cell and enforce uniform size */
  width: 100%;
  height: 24px; /* consistent height for all month buttons */
  box-sizing: border-box;
  padding: 0 0.6rem; /* horizontal padding while keeping fixed height */
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #fff;
  cursor: pointer;
  text-align: left; /* left-align label next to the marker */
  font-size: 0.65rem; /* slightly larger for readability */
  transition: background-color 0.12s, color 0.12s;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: flex-start; /* keep marker and label aligned consistently */
}

.MonthRangePicker_monthButton__uPx2F::before {
  content: "";
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid #dcdcdc; /* subtle ring for unselected */
  margin-left: 8px; /* small left margin so marker is inset slightly */
  margin-right: 12px; /* consistent space between marker and label */
  background-color: #ffffff;
  transition: background-color 0.12s, border-color 0.12s, box-shadow 0.12s;
}

.MonthRangePicker_monthButton__uPx2F:hover:not(:disabled) {
  background-color: #f1f5f9;
}

.MonthRangePicker_monthButton__uPx2F:disabled {
  color: rgb(228, 228, 229);
  cursor: not-allowed;
  background-color: rgb(187, 188, 188);
}

.MonthRangePicker_monthButton__uPx2F:disabled::before {
  background-color: #eee;
  border-color: #ddd;
}

.MonthRangePicker_selected__W29DL {
  /* Visual only: keep same padding/size as .monthButton to avoid layout shift */
  background-color: #327ec9; /* primary blue */
  border-color: #327ec9;
  color: #ffffff;
  box-sizing: border-box; /* ensure same box model */
}

.MonthRangePicker_selected__W29DL::before {
  background-color: #ffffff;
  border-color: #327ec9;
  box-shadow: 0 0 0 3px rgba(47, 136, 255, 0.12) inset;
  width: 14px;
  height: 14px;
}

.MonthRangePicker_inRange__6KGpc {
  background-color: #327ec9; /* primary blue */
  border-color: #327ec9;
  color: #ffffff;
  box-sizing: border-box;
}

.MonthRangePicker_inRange__6KGpc::before {
  background-color: #ffffff;
  border-color: #2f88ff;
  width: 14px;
  height: 14px;
}

.MonthRangePicker_header__3QM1m .MonthRangePicker_clearButton__uCX5e {
  background: none;
  border: none;
  cursor: pointer;
  font-weight: bold;

  /* Your custom styles will now be applied */
  color: #659cd6;
  font-size: 0.75rem;
}

/* compact modifier for very tight layouts */
.MonthRangePicker_compactPicker__GeU\\+l {
  width: 240px;
}

/* Override generated MUI Stack gap for larger screens (remove excessive 32px gap) */
@media (min-width: 600px) {
  /* Target the exact generated classname provided; use !important to override MUI styles */
  .css-1iak8fh-MuiStack-root {
    gap: 0 !important;
  }
}

.MonthRangePicker_tooltipContainer__F72GH {
  position: static;
  display: inline-block; /* Or block, depending on your layout */
}

/* 2. The tooltip text - hidden by default */
.MonthRangePicker_tooltipText__UHp42 {
  visibility: hidden;
  opacity: 0;

  /* Tooltip Appearance */
  /* translucent background for less visual weight */
  /* much more translucent so it doesn't block underlying content */
  background-color: rgba(17, 24, 39, 0.35); /* tailwind slate-900 at 35% */
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 3px 6px; /* even tighter padding */
  font-size: 0.68rem; /* slightly smaller font for compactness */
  /* subtle blur to improve readability against busy backgrounds */
  backdrop-filter: blur(3px);

  /* Positioning */
  position: absolute;
  z-index: 3;
  bottom: calc(100% + 8px); /* Position above the button */
  left: 50%;
  transform: translateX(-50%); /* Center within the month grid */
  width: min(460px, calc(100% - 12px));
  max-width: calc(100% - 12px);

  /* Fade-in transition */
  transition: opacity 0.3s;

  /* Prevent line breaks */
  white-space: normal;
  overflow-wrap: anywhere;
}

/* 3. The little arrow below the tooltip */
.MonthRangePicker_tooltipText__UHp42::after {
  content: "";
  position: absolute;
  top: 100%; /* At the bottom of the tooltip */
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  /* arrow color matches translucent background (use semi-opaque border) */
  border-color: rgba(17, 24, 39, 0.35) transparent transparent transparent;
}

/* 4. Show the tooltip on hover */
.MonthRangePicker_tooltipContainer__F72GH:hover .MonthRangePicker_tooltipText__UHp42 {
  visibility: visible;
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/UaeMt/Calendarview/MonthRangePicker.module.css"],"names":[],"mappings":"AAAA;EACE,qEAAqE;EACrE,WAAW;EACX,gBAAgB,EAAE,wCAAwC;EAC1D,sBAAsB;EACtB,eAAe,EAAE,oCAAoC;EACrD,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,qBAAqB,EAAE,qBAAqB;EAC5C,2CAA2C,EAAE,mBAAmB;AAClE;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB,EAAE,wBAAwB;AAC7C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY,EAAE,wCAAwC;EACtD,kBAAkB;AACpB;;AAEA;EACE,gEAAgE;EAChE,WAAW;EACX,YAAY,EAAE,4CAA4C;EAC1D,sBAAsB;EACtB,iBAAiB,EAAE,kDAAkD;EACrE,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB,EAAE,wCAAwC;EAC1D,kBAAkB,EAAE,oCAAoC;EACxD,+CAA+C;EAC/C,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B,EAAE,+CAA+C;AAC9E;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB,EAAE,+BAA+B;EAC1D,gBAAgB,EAAE,kDAAkD;EACpE,kBAAkB,EAAE,8CAA8C;EAClE,yBAAyB;EACzB,wEAAwE;AAC1E;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,8EAA8E;EAC9E,yBAAyB,EAAE,iBAAiB;EAC5C,qBAAqB;EACrB,cAAc;EACd,sBAAsB,EAAE,0BAA0B;AACpD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,oDAAoD;EACpD,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;;EAEjB,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,YAAY;AACd;;AAEA,oFAAoF;AACpF;EACE,yFAAyF;EACzF;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,qBAAqB,EAAE,uCAAuC;AAChE;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,UAAU;;EAEV,uBAAuB;EACvB,kDAAkD;EAClD,iEAAiE;EACjE,wCAAwC,EAAE,8BAA8B;EACxE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB,EAAE,yBAAyB;EAC3C,kBAAkB,EAAE,0CAA0C;EAC9D,gEAAgE;EAChE,0BAA0B;;EAE1B,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,wBAAwB,EAAE,8BAA8B;EACxD,SAAS;EACT,2BAA2B,EAAE,iCAAiC;EAC9D,oCAAoC;EACpC,4BAA4B;;EAE5B,uBAAuB;EACvB,wBAAwB;;EAExB,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAE,iCAAiC;EAC5C,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,wEAAwE;EACxE,wEAAwE;AAC1E;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,UAAU;AACZ","sourcesContent":[".pickerContainer {\n  /* Make picker fill its parent column and allow it to shrink to fit */\n  width: 100%;\n  max-width: 280px; /* keep the original compact max width */\n  box-sizing: border-box;\n  padding: 0.4rem; /* small padding to tighten layout */\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  background-color: #ffffff;\n  transition: all 0.12s ease-in-out;\n}\n.pickerContainer.open {\n  border-color: #d21919; /* highlight border */\n  box-shadow: 0 0 8px rgba(25, 118, 210, 0.4); /* glow when open */\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  font-size: 0.9rem; /* smaller header text */\n}\n\n.header button {\n  background: none;\n  border: none;\n  font-size: 0.85rem;\n  cursor: pointer;\n  color: #007bff;\n}\n\n.header button:disabled {\n  color: #9e9d9d;\n  cursor: not-allowed;\n}\n\n.monthsGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.08rem; /* almost no gap between month buttons */\n  position: relative;\n}\n\n.monthButton {\n  /* Make the button fill the grid cell and enforce uniform size */\n  width: 100%;\n  height: 24px; /* consistent height for all month buttons */\n  box-sizing: border-box;\n  padding: 0 0.6rem; /* horizontal padding while keeping fixed height */\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  background-color: #fff;\n  cursor: pointer;\n  text-align: left; /* left-align label next to the marker */\n  font-size: 0.65rem; /* slightly larger for readability */\n  transition: background-color 0.12s, color 0.12s;\n  color: #333;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start; /* keep marker and label aligned consistently */\n}\n\n.monthButton::before {\n  content: \"\";\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 2px solid #dcdcdc; /* subtle ring for unselected */\n  margin-left: 8px; /* small left margin so marker is inset slightly */\n  margin-right: 12px; /* consistent space between marker and label */\n  background-color: #ffffff;\n  transition: background-color 0.12s, border-color 0.12s, box-shadow 0.12s;\n}\n\n.monthButton:hover:not(:disabled) {\n  background-color: #f1f5f9;\n}\n\n.monthButton:disabled {\n  color: rgb(228, 228, 229);\n  cursor: not-allowed;\n  background-color: rgb(187, 188, 188);\n}\n\n.monthButton:disabled::before {\n  background-color: #eee;\n  border-color: #ddd;\n}\n\n.selected {\n  /* Visual only: keep same padding/size as .monthButton to avoid layout shift */\n  background-color: #327ec9; /* primary blue */\n  border-color: #327ec9;\n  color: #ffffff;\n  box-sizing: border-box; /* ensure same box model */\n}\n\n.selected::before {\n  background-color: #ffffff;\n  border-color: #327ec9;\n  box-shadow: 0 0 0 3px rgba(47, 136, 255, 0.12) inset;\n  width: 14px;\n  height: 14px;\n}\n\n.inRange {\n  background-color: #327ec9; /* primary blue */\n  border-color: #327ec9;\n  color: #ffffff;\n  box-sizing: border-box;\n}\n\n.inRange::before {\n  background-color: #ffffff;\n  border-color: #2f88ff;\n  width: 14px;\n  height: 14px;\n}\n\n.header .clearButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-weight: bold;\n\n  /* Your custom styles will now be applied */\n  color: #659cd6;\n  font-size: 0.75rem;\n}\n\n/* compact modifier for very tight layouts */\n.compactPicker {\n  width: 240px;\n}\n\n/* Override generated MUI Stack gap for larger screens (remove excessive 32px gap) */\n@media (min-width: 600px) {\n  /* Target the exact generated classname provided; use !important to override MUI styles */\n  :global(.css-1iak8fh-MuiStack-root) {\n    gap: 0 !important;\n  }\n}\n\n.tooltipContainer {\n  position: static;\n  display: inline-block; /* Or block, depending on your layout */\n}\n\n/* 2. The tooltip text - hidden by default */\n.tooltipText {\n  visibility: hidden;\n  opacity: 0;\n\n  /* Tooltip Appearance */\n  /* translucent background for less visual weight */\n  /* much more translucent so it doesn't block underlying content */\n  background-color: rgba(17, 24, 39, 0.35); /* tailwind slate-900 at 35% */\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 3px 6px; /* even tighter padding */\n  font-size: 0.68rem; /* slightly smaller font for compactness */\n  /* subtle blur to improve readability against busy backgrounds */\n  backdrop-filter: blur(3px);\n\n  /* Positioning */\n  position: absolute;\n  z-index: 3;\n  bottom: calc(100% + 8px); /* Position above the button */\n  left: 50%;\n  transform: translateX(-50%); /* Center within the month grid */\n  width: min(460px, calc(100% - 12px));\n  max-width: calc(100% - 12px);\n\n  /* Fade-in transition */\n  transition: opacity 0.3s;\n\n  /* Prevent line breaks */\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n/* 3. The little arrow below the tooltip */\n.tooltipText::after {\n  content: \"\";\n  position: absolute;\n  top: 100%; /* At the bottom of the tooltip */\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  /* arrow color matches translucent background (use semi-opaque border) */\n  border-color: rgba(17, 24, 39, 0.35) transparent transparent transparent;\n}\n\n/* 4. Show the tooltip on hover */\n.tooltipContainer:hover .tooltipText {\n  visibility: visible;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pickerContainer": `MonthRangePicker_pickerContainer__3u5Jx`,
	"open": `MonthRangePicker_open__ccewb`,
	"header": `MonthRangePicker_header__3QM1m`,
	"monthsGrid": `MonthRangePicker_monthsGrid__s9We+`,
	"monthButton": `MonthRangePicker_monthButton__uPx2F`,
	"selected": `MonthRangePicker_selected__W29DL`,
	"inRange": `MonthRangePicker_inRange__6KGpc`,
	"clearButton": `MonthRangePicker_clearButton__uCX5e`,
	"compactPicker": `MonthRangePicker_compactPicker__GeU+l`,
	"tooltipContainer": `MonthRangePicker_tooltipContainer__F72GH`,
	"tooltipText": `MonthRangePicker_tooltipText__UHp42`
};
export default ___CSS_LOADER_EXPORT___;
